export default "__VITE_ASSET__BgW19IAH__"